import React from "react";
import Place from "./Place/Place";
import "./Places.css";

const Places = () => {
  // Функция для получения пути к изображению
  const getImagePath = (imageName) =>
    require(`../../assets/images/places/${imageName}`).default ||
    require(`../../assets/images/places/${imageName}`);

  const placesData = [
    {
      id: 1,
      title: "Куршская коса",
      image: getImagePath("place1.png"),
      url: "https://park-kosa.ru",
      urlText: "park-kosa.ru",
      texts: [
        "Здесь, посреди лесов и песчаных дюн, вы сможете увидеть два водных горизонта — спокойного Куршского залива с одной стороны и подёрнутого рябью волн Балтийского моря с другой. Уникальная природная зона на краю российского анклава.",
        "На этом Калининградская область не заканчивается. Для путешественника и исследователя там же по соседству — самая западная точка России, Балтийская коса, — и немецкое наследие россыпи небольших приморских городов. Атмосфера здешних мест исключает суету, окуная в спокойствие природы и запах стального, прохладного моря.",
      ],
    },
    {
      id: 2,
      title: "Кольский",
      image: getImagePath("place2.png"),
      url: "https://yourshot.nationalgeographic.com/photos/?keywords=kolskiy",
      urlText: "National Geographic",
      texts: [
        "Почти весь полуостров находится за Полярным кругом. Саамская тундра, от которой на юг — тайга, а на север — Ледовитый океан, прикидывающийся Баренцевым морем.",
        "Возможно, вы смотрели Звягинцева и даже слышали историю арктического фестиваля в Териберке. Возможно, слово «Хибины» не осталось под снегом школьных воспоминаний об уроках географии. Возможно, вы не интересовались пронизывающей земную кору сверхглубокой скважиной, а от апатитов вас давно накрывает апатия. Но ваша мечта увидеть северное сияние начинает сбываться с билетом в Мурманск.",
      ],
    },
    {
      id: 3,
      title: "Алтай",
      image: getImagePath("place3.png"),
      url: "https://www.facebook.com/vera.bashmakova/posts/10156011613718822",
      urlText: "Facebook",
      texts: [
        "Алтай — одно из красивейших мест в России. В первую очередь из-за гор: если ехать вдоль хребта, вы увидите склоны, усыпанные соснами, горные реки и озёра. А если вы откроете в автомобиле окна, сможете познакомиться с невидимым чудом здешних мест — горным воздухом.",
        "Климат на Алтае умеренный, поэтому ехать сюда лучше всего летом. Так вы увидите всё разнообразие местной флоры и фауны. По лесам Алтая бродят лоси, над хребтами летают орлы, а на равнинах пасутся косули. И знаменитые манулы — тоже обитатели Алтайского края.",
      ],
    },
    {
      id: 4,
      title: "Зимний Байкал",
      image: getImagePath("place4.png"),
      url: "https://vk.com/baikalmile",
      urlText: "https://vk.com/baikalmile",
      texts: [
        "Всем известен Байкал как крупнейшее озеро в мире. Многие также знают, что это самый большой источник пресной воды и одно из красивейших мест в России.",
        "Конечно, это всё так. Но Байкал ещё идеальное место для соревнований по скийорингу. Это такой вид спорта, когда лыжник привязывает себя к мотоциклу, и тандем старается развить как можно бóльшую скорость на льду. В марте 2019 года на фестивале «Байкальская миля» был поставлен мировой рекорд — 197.011 км/ч.",
      ],
    },
    {
      id: 5,
      title: "Карелия",
      image: getImagePath("place4.png"),
      url: "https://vodlozero.ru/",
      urlText: "https://vodlozero.ru/",
      texts: [
        "Сибирь заканчивается не на Урале, а в Карелии: образующая тайгу сибирская лиственница не растёт западнее Водлозера. Зато здесь она вымахивает на 30 метров — леса карельских национальных парков из-за непроходимых болот никогда не знали топора. Некоторым соснам уже больше чем полтысячелетия. Прикоснитесь к живому существу, видевшему солнце раньше, чем увидал его Иван Грозный. В девственном лесу на сотню километров не встретишь тропы. А на редких тропинках деревья в паре метров от земли помечены медвежьими когтями. Чтобы все знали, кто тут хозяин.",
      ],
    },
  ];

  return (
    <section className="places">
      {placesData.map((place) => (
        <Place key={place.id} {...place} />
      ))}
    </section>
  );
};

export default Places;
